import { render, staticRenderFns } from "./PluginsSelectSnackbar.vue?vue&type=template&id=3d9dccd7&scoped=true"
import script from "./PluginsSelectSnackbar.vue?vue&type=script&lang=js"
export * from "./PluginsSelectSnackbar.vue?vue&type=script&lang=js"
import style0 from "./PluginsSelectSnackbar.vue?vue&type=style&index=0&id=3d9dccd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9dccd7",
  null
  
)

export default component.exports